<template>
  <v-flex class="transferFunds fill-height" data-qa="domesticpayments-flex-r7vamh">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <v-flex v-if="!reviewScreen" xs12 sm12 md12 lg12 xl12 data-qa="domesticpayments-flex-nt8qib">
      <v-navigation-drawer
        v-model="openPayee"
        :width="360"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList"
       data-qa="domesticpayments-navigation-drawer-1mldyw">
        <v-card height="100%" data-qa="domesticpayments-card-f5jv2m">
          <v-toolbar color="white" light data-qa="domesticpayments-toolbar-877fs">
            <v-toolbar-title data-qa="domesticpayments-toolbar-title-8a8c">
              <v-list-item-title
                v-if="!enablePayeeForm && !enableSortCodeSearchForm"
                class="text-h6"
                 data-qa="domesticpayments-list-item-title-gynidc">{{ $t("domesticPayments.selectPayeeLabel") }}
              </v-list-item-title>
              <v-list-item-title
                v-if="enablePayeeForm || enableSortCodeSearchForm"
                class="text-h6"
                 data-qa="domesticpayments-list-item-title-zoqmn">
                {{ appSettingsNA.enableNominatedAccountFeatures ?
                  $t("domesticPayments.addPayeeHeadingNA") :
                  $t("domesticPayments.addPayeeHeading") }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="enableSortCodeSearchForm" data-qa="domesticpayments-list-item-subtitle-5cr2ir">
                <font :color="darkColor">{{
                  $t("domesticPayments.searchSortCode")
                }}</font>
              </v-list-item-subtitle>
            </v-toolbar-title>
            <v-spacer data-qa="domesticpayments-spacer-tr9zjs"></v-spacer>
            <v-btn @click.stop="onClosePayeeDrawer" icon data-qa="domesticpayments-btn-2aswnk">
              <v-icon class="material-symbols-outlined" data-qa="domesticpayments-icon-5l3eq">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider data-qa="domesticpayments-divider-ofqra9"  />
          <!-- Payees -->
          <v-list-item
            two-line
            v-if="!enablePayeeForm && !enableSortCodeSearchForm"
           data-qa="domesticpayments-list-item-ypdxlq">
            <v-list-item-content data-qa="domesticpayments-list-item-content-9brvn8">
              <v-list-item-title data-qa="domesticpayments-list-item-title-vx79ta">
                <v-text-field
                  v-model="searchPayee"
                  :label="$t('domesticPayments.payeeSearchLabel')"
                  :color="primaryColor"
                  prepend-inner-icon="mdi-magnify"
                  class="transferFunds--custom-textfield"
                  clearable
                  filled
                 data-qa="domesticpayments-text-field-oqr4q1"></v-text-field>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list
            v-if="!enablePayeeForm && !enableSortCodeSearchForm"
            two-line
            flat
            class="mt-n8"
           data-qa="domesticpayments-list-qdqk6m">
            <v-row v-if="isAddPayeePermitted.ukfps" no-gutters justify="end" class="px-3" data-qa="domesticpayments-row-yn75eo">
              <v-btn
                @click="enablePayeeForm = true"
                :color="primaryColor"
                dark
                class="text-capitalize py-2 px-4"
               data-qa="domesticpayments-btn-y5perg">
                {{ appSettingsNA.enableNominatedAccountFeatures ?
                  $t("payee.nominatedAddNewPayeeBtn") :
                  $t("domesticPayments.addPayeeBtn") }}
              </v-btn>
            </v-row>
            <v-flex v-if="showFilters" class="mx-5 py-4" data-qa="domesticpayments-flex-7a8v4k">
              <v-tabs
                :color="primaryColor"
                v-model="showLinkedAccounts"
                class="text-capitalize"
               data-qa="domesticpayments-tabs-sn0gfm">
                <v-tab class="text-none font-weight-bold" data-qa="domesticpayments-tab-anm88n">
                  {{ $t("payee.linkedAccBtn") }}
                </v-tab>
                <v-tab class="text-none font-weight-bold" data-qa="domesticpayments-tab-tvg6xc">
                  {{ $t("payee.payeeBtn") }}
                </v-tab>
              </v-tabs>
            </v-flex>
            <template v-if="payeeSearchFilter.length">
             <template v-for="(item, index) in payeeSearchFilter">
              <v-list-item
                :key="item.accountIdentification"
                @click="togglePayee(item)"
                :data-qa="`domesticpayments-list-item-xqg4e-${index}`">
                <v-list-item-content :data-qa="`domesticpayments-list-item-content-k2ldl5${index}`">
                  <v-list-item-title
                    v-text="item.name"
                    class="text--primary"
                    :data-qa="`domesticpayments-list-item-title-zj10by${index}`"></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="
                      `${item.accountIdentification} | ${item.bankIdentifier}`
                    "
                   :data-qa="`domesticpayments-list-item-subtitle-pbd2i${index}`"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="showDivider(index, beneficiaryList)"
                :key="index"
               :data-qa="`domesticpayments-divider-n3j1io${index}`"></v-divider>
             </template>
          </template>
          <v-row v-else no-gutters justify="center" class="pa-2" data-qa="domesticpayments-row-m2198">
            {{ $t('payee.notAvailable')}}
          </v-row>
          </v-list>
          <v-list v-if="enablePayeeForm" data-qa="domesticpayments-list-gdea8">
            <v-list-item data-qa="domesticpayments-list-item-77ruyb">
              <v-list-item-content data-qa="domesticpayments-list-item-content-jn3y1r">
                <v-form ref="payeeForm" v-model="isPayeeFormValid" data-qa="domesticpayments-form-o8nmmn">
                  <v-text-field
                    v-model="payeeForm.accountName"
                    :label="$t('domesticPayments.payeeAccountNameLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    :maxlength="payeeForm.payeeNameMaxLen
                      ? payeeForm.payeeNameMaxLen
                      : false"
                    filled
                    class="transferFunds--custom-textfield"
                   data-qa="domesticpayments-text-field-ytaldr"></v-text-field>
                  <v-text-field
                    v-model="payeeForm.toAccount"
                    :label="$t('domesticPayments.payeeAccNoLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    filled
                    required
                    type="password"
                    onCopy="return false"
                    onpaste="return false"
                    class="transferFunds--custom-textfield"
                    @keydown="$formatter.validateNumberInput($event)"
                   data-qa="domesticpayments-text-field-b77uqf"></v-text-field>
                  <v-text-field
                    v-model="payeeForm.reEnteredToAccount"
                    :label="$t('domesticPayments.payeeReEnterAccNoLabel')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    :error="
                      isNumberMatched(
                        payeeForm.toAccount,
                        payeeForm.reEnteredToAccount
                      )
                    "
                    :error-messages="
                      isNumberMatched(
                        payeeForm.toAccount,
                        payeeForm.reEnteredToAccount
                      )
                        ? $t('domesticPayments.errorMsgAccNumMatch')
                        : ''
                    "
                    filled
                    onCopy="return false"
                    onpaste="return false"
                    class="transferFunds--custom-textfield"
                    @keydown="$formatter.validateNumberInput($event)"
                   data-qa="domesticpayments-text-field-hnkpq3"></v-text-field>
                  <v-layout class="pa-0" data-qa="domesticpayments-layout-8zyg3b">
                    <v-flex xs8 sm8 md8 lg8 xl8 data-qa="domesticpayments-flex-0cy1zq">
                      <v-text-field
                        v-model="payeeForm.sortCode"
                        :label="$t('addNewPayee.sortCode')"
                        :color="primaryColor"
                        :rules="[rules.requiredWithNoErrRule]"
                        readonly
                        class="transferfunds--nonEditable-textfield"
                       data-qa="domesticpayments-text-field-euw7z"></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" data-qa="domesticpayments-flex-ltevl9">
                      <v-btn
                        @click="showSearchForm"
                        :color="primaryColor"
                        outlined
                        class="text-none subtitle-2 font-weight-regular"
                       data-qa="domesticpayments-btn-u6dxuq">
                        <v-icon class="material-symbols-outlined" data-qa="domesticpayments-icon-qhmlrg">search</v-icon>
                        {{ $t("domesticPayments.searchSortCodeBtn") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-text-field
                    v-model="payeeForm.bankName"
                    :label="$t('addNewPayee.bankName')"
                    :color="primaryColor"
                    :rules="[rules.requiredWithNoErrRule]"
                    readonly
                    class="transferfunds--nonEditable-textfield"
                   data-qa="domesticpayments-text-field-zhxncl"></v-text-field>
                  <!--Whose account? own/others - enable the radio buttons only when nominated account feature is disabled.
                      if nominated account feature is ON then user can add only own accounts-->
                  <v-flex class="px-3 font-weight-bold" xs12 sm12 md12 lg12 xl12 v-if="!appSettingsNA.enableNominatedAccountFeatures" data-qa="domesticpayments-flex-y5uwy">
                    {{$t('addNewPayee.whoseBankAccount')}}
                    <v-radio-group
                      v-model="isOwnAccLinked"
                      :rules="[fieldRules]"
                      row
                      class="font-weight-regular"
                       data-qa="domesticpayments-radio-group-y8ar2p">
                        <v-radio
                        :label="$t('addNewPayee.ownAccount')"
                        value="own"
                        :color="secondaryColor"
                         data-qa="domesticpayments-radio-06jq8"></v-radio>
                        <v-radio
                        :label="$t('addNewPayee.othersAccount')"
                        value="others"
                        :color="secondaryColor"
                         data-qa="domesticpayments-radio-sojna8"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-row v-if="isAddPayeePermitted.ukfps" no-gutters class="pa-2" data-qa="domesticpayments-row-ndvwi7">
                    <v-btn
                      @click="onAddPayee"
                      :color="primaryColor"
                      :disabled="
                        !isPayeeFormValid
                      "
                      class="white--text text-capitalize py-2 px-4"
                     data-qa="domesticpayments-btn-ap20t">
                      {{ appSettingsNA.enableNominatedAccountFeatures ?
                        $t("addNewPayee.ownAccountTitle") :
                        $t("addNewPayee.addPayeeBtn") }}
                    </v-btn>
                  </v-row>
                </v-form>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="enableSortCodeSearchForm" data-qa="domesticpayments-list-8bgg7p">
            <v-list-item data-qa="domesticpayments-list-item-l332hj">
              <v-list-item-content data-qa="domesticpayments-list-item-content-p8x5um">
                <v-row no-gutters class="pb-0" data-qa="domesticpayments-row-e3i46o">
                  <v-alert
                    icon="mdi-information-outline"
                    class="v-alert--info"
                   data-qa="domesticpayments-alert-40gqla">
                    <font class="caption font-weight-regular">
                      {{ $t("domesticPayments.searchSortCodeInfo") }}
                    </font>
                  </v-alert>
                </v-row>
                <v-form
                  ref="searchSortCodeForm"
                  v-model="isSortCodeSearchFormValid"
                 data-qa="domesticpayments-form-zqle7">
                  <Form
                    :config="{
                      label: '',
                      name: 'SearchSortCode',
                      isEnabled: true,
                      toolbar: false,
                      form: schema.searchSortCodeForm
                    }"
                  ></Form>
                  <v-row no-gutters class="pa-2" data-qa="domesticpayments-row-7ah8ej">
                    <v-btn
                      @click="onSearchSortCode"
                      :color="primaryColor"
                      :disabled="isSearchDataValid()"
                      style="margin-left: 12px;"
                      class="white--text text-capitalize py-2 px-4"
                     data-qa="domesticpayments-btn-bivn8l">
                      {{ $t("domesticPayments.searchBtn") }}
                    </v-btn>
                  </v-row>
                </v-form>
              </v-list-item-content>
            </v-list-item>
            <font
              v-if="sortCodeResults.length"
              class="pl-4 text-h6 font-weight-light"
              >{{ $t("domesticPayments.searchResultsTitle") }}</font
            >
            <div v-if="sortCodeResults.length" data-qa="domesticpayments-div-uledan">
              <template v-for="(data, index) in sortCodeResults">
                <v-list-item :key="data.nationalid" :data-qa="`domesticpayments-list-item-eshjp9-${index}`">
                  <v-list-item-content :data-qa="`domesticpayments-list-item-content-vp5umi-${index}`">
                    <v-flex xs8 sm8 md8 lg8 xl8 :data-qa="`domesticpayments-flex-mwh2p5-${index}`">
                      <v-list-item-title :data-qa="`domesticpayments-list-item-title-xwvz2j-${index}`">
                        <font class="body-2 font-weight-light">{{
                          convertToCapitalisedSentence(data.instname)
                        }}</font>
                      </v-list-item-title>
                      <v-list-item-subtitle :data-qa="`domesticpayments-list-item-subtitle-8wnm7t-${index}`">
                        <font class="caption">
                          {{ convertToCapitalisedSentence(data.branchinfo) }}
                        </font>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle :data-qa="`domesticpayments-list-item-subtitle-cpolwf-${index}`">
                        <font class="caption font-weight-bold">{{
                          $t("domesticPayments.sortCodeLabel")
                        }}</font
                        ><font class="caption font-weight-bold">{{
                          maskSortCode(data.nationalid)
                        }}</font>
                      </v-list-item-subtitle>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" :data-qa="`domesticpayments-flex-9llc-${index}`">
                      <v-btn
                        @click="onSortCodeSelect(data)"
                        :color="primaryColor"
                        outlined
                        class="text-none py-2 px-4"
                        :data-qa="`domesticpayments-btn-i7osl-${index}`">
                        {{ $t("domesticPayments.selectBtn") }}
                      </v-btn>
                    </v-flex>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="showDivider(index, sortCodeResults)"
                  :key="index"
                  :data-qa="`domesticpayments-divider-uv7ljs-${index}`"></v-divider>
              </template>
            </div>
            <div
              v-if="
                !searchSortCodeForm.isSearchAvailable && !sortCodeResults.length
              "
             data-qa="domesticpayments-div-caucq4">
              <font class="pl-4 text-h6 font-weight-light">{{
                $t("domesticPayments.searchResultsTitle")
              }}</font>
              <v-list-item data-qa="domesticpayments-list-item-q238y">
                <font class="body-2 font-weight-light">{{
                  $t("domesticPayments.noSortCode")
                }}</font>
              </v-list-item>
            </div>
          </v-list>
        </v-card>
      </v-navigation-drawer>

      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="domesticpayments-flex-wxoow">
        <Loader v-show="loaderEnabled"/>
        <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="domesticpayments-layout-bwl61dp">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px' }"
           data-qa="domesticpayments-flex-y39e5e">
            <v-container class="transferFunds--title-padding" data-qa="domesticpayments-container-raf37a">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="domesticpayments-flex-buulu">
                <v-row no-gutters data-qa="domesticpayments-row-sg49qj">
                  <v-layout row wrap class="pb-2" data-qa="domesticpayments-layout-spdug5">
                    <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="domesticpayments-flex-3scn0l">
                      <v-row justify="end" data-qa="domesticpayments-row-utf5t">
                        <v-avatar :tile="false" size="35" color="white" data-qa="domesticpayments-avatar-6gnn38">
                          <!-- <v-icon :color="primaryColor" data-qa="domesticpayments-icon-c7k8k">mdi-sync</v-icon> -->
                          <dob-icon iconKey="domesticpayments_bannerIcon" />
                        </v-avatar>
                      </v-row>
                    </v-flex>
                    <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="domesticpayments-flex-fdbmq">
                      <v-row no-gutters data-qa="domesticpayments-row-urzq09">
                        <font class="text-h5 font-weight-light white--text">
                          {{ $t("domesticPayments.title") }}</font
                        >
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-flex>
            </v-container>
          </v-flex>
        </v-layout>

        <v-flex
          xs12
          sm12
          md12
          lg10
          xl10
          class="transferFunds--content-padding transferFunds--overlayCardFlex"
         data-qa="domesticpayments-flex-yw4x3">
          <v-layout row wrap class="transferFunds--content-padding" data-qa="domesticpayments-layout-90a9s">
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="domesticpayments-flex-cxamjc">
              <v-card data-qa="domesticpayments-card-5mkgb">
                <v-container class="pt-4" data-qa="domesticpayments-container-qo3kl8">
                  <v-tabs
                    v-if="enableRecurringPaymentsOption && !isNoticeSelected && !isLisaSelected"
                    v-model="paymentMode"
                    :color="primaryColor"
                    class="pl-6"
                    @change="onPaymentModeChanged()"
                   data-qa="domesticpayments-tabs-4zd3zt">
                    <v-tab @click="resetPage" data-qa="domesticpayments-tab-7n8tg9">
                      <font class="text-capitalize">{{
                        $t("domesticPayments.firstSubSection")
                      }}</font>
                    </v-tab>
                    <v-tab @click="resetPage" data-qa="domesticpayments-tab-ms7xvnq">
                      <font class="text-capitalize">{{
                        $t("domesticPayments.secondSubSection")
                      }}</font>
                    </v-tab>
                  </v-tabs>
                  <v-form
                    ref="form"
                    v-model="isFormValid"
                    :lazy-validation="false"
                   data-qa="domesticpayments-form-0cas8">
                    <v-layout row justify-space-between data-qa="domesticpayments-layout-fwec8m">
                      <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="domesticpayments-flex-a0worn">
                        <PaymentSourceSelect
                          v-model="form.selectedAccount"
                          @input="verifyAccount"
                          @change="verifyNominatedAccount"
                          :items="sourceAccounts"
                          :label="$t('domesticPayments.selectAccountLabel')"
                          :error="isFormAccounts"
                          :error-messages="isFormAccounts ? $t('domesticPayments.accountsError'): ''"
                          :rules="[rules.requiredRule || !isFormAccounts]"
                        />
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="domesticpayments-flex-i160s">
                        <v-text-field
                          v-model="payeeList"
                          @focus="listPayee"
                          :color="primaryColor"
                          :rules="[rules.requiredRule || !isFormAccounts]"
                          :label="$t('domesticPayments.selectPayeeLabel')"
                          :hint="
                            payeeAccountName || selectedPayeeSortCode
                              ? `${payeeAccountName} | ${selectedPayeeSortCode}`
                              : ''
                          "
                          persistent-hint
                          filled
                          readonly
                          append-icon="mdi-chevron-right"
                          class="transferFunds--custom-textfield"
                         data-qa="domesticpayments-text-field-63qok2j"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="domesticpayments-flex-ggmgg">
                        <v-text-field
                          v-model="transferAmount"
                          @input="
                            verifyBalance();
                            restrictDecimal($event);
                          "
                          @keypress="numbersOnly"
                          :label="$t('domesticPayments.amountLabel')"
                          :prefix="
                            $formatter.currency.getCurrencySymbol(
                              UKFPSpayemntTemplate.currency
                            )
                          "
                          :hint="`${$t('domesticPayments.maxAmountLimit')}  - ${$formatter.currency.format(
                            UKFPSpayemntTemplate.transactionLimit,
                            UKFPSpayemntTemplate.currency
                          )}`"
                          :color="primaryColor"
                          :rules="[
                            rules.requiredAmountRule,
                            rules.greaterThanZero,
                            rules.isLimitValid
                          ]"
                          :error="hasExceededBalance"
                          :error-messages="hasExceededBalance ? $t('domesticPayments.fundsError') : ''"
                          :class="[
                            'transferFunds--custom-textfield custom-amount',
                            'transferFunds--amountCurrencySymbolDefault',
                            transferAmount && transferAmount.length
                              ? false
                              : 'transferFunds--amountCurrencySymbol',
                          ]"
                          filled
                          persistent-hint
                          type="number"
                         data-qa="domesticpayments-text-field-pmk98">
                          <template
                            v-slot:append
                            v-if="selectedAccount?.accountType === 'TXLA'"
                          >
                            <TransferFundsLisaTooltip />
                          </template>
                        </v-text-field>
                      </v-flex>
                      <v-flex
                        v-if="paymentMode !== 0"
                        xs12
                        sm12
                        md6
                        lg6
                        xl6
                        class="px-6 pt-3"
                       data-qa="domesticpayments-flex-hyiql7">
                        <v-select
                          v-model="paymentFrequency"
                          :label="$t('domesticPayments.frequencyDaysLabel')"
                          :items="frequencyDays"
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          autocomplete
                          return-object
                          filled
                          item-text="state"
                          item-value="val"
                          item-key="val"
                          max-height="auto"
                          data-qa="paymentFrequency"
                          class="transferFunds--custom-textfield"
                        ></v-select>
                      </v-flex>
                       <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" v-if="paymentMode !== 0" data-qa="domesticpayments-flex-ax3tpf">
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            offset-y
                            transition="scale-transition"
                            min-width="290px"
                           data-qa="domesticpayments-menu-6x2d4a">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="repeatFromDate"
                                :label="
                                  paymentMode === 0
                                    ? $t(
                                        'transferfunds.quickPaymentDateLabel'
                                      )
                                    : $t('transferfunds.paymentDateLabel')
                                "
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                filled
                                readonly
                                data-qa="fromDate"
                                append-icon="mdi-calendar"
                                class="transferFunds--custom-textfield"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="repeatFormattedDate"
                              @input="menu = false"
                              :allowed-dates="allowedDates"
                              :min="repeatMinAllowedDate"
                              :color="primaryColor"
                              filled
                              data-qa="fromDate"
                              @change="repeatUpdateDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md6
                        lg6
                        xl6
                        class="px-6 pt-3"
                        v-if="paymentMode !== 0"
                       data-qa="domesticpayments-flex-y4vx3e">
                        <v-text-field
                          v-model="frequencyMonths"
                          :label="$t('domesticPayments.selectTimes')"
                          :rules="[rules.requiredRule, rules.minValue, rules.maxValue]"
                          :color="primaryColor"
                          @keydown="filterKey"
                          filled
                          onCopy="return false"
                          onpaste="return false"
                          type="number"
                          class="transferFunds--custom-textfield"
                         data-qa="domesticpayments-text-field-gwhjr8"></v-text-field>
                      </v-flex>
                      <v-flex v-if="paymentMode === 0" xs12 sm12 md6 lg6 xl6 class="px-7 pt-4" data-qa="domesticpayments-flex-vd3mof">
                        <v-menu
                            v-model="menuOneTimePayment"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            offset-y
                            transition="scale-transition"
                            :min-width="isNoticeSelected || isLisaSelected ? '0px' : '290px'"
                           data-qa="domesticpayments-menu-jiwdgh">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="formattedDateOTP"
                                :label="$t('transferfunds.quickPaymentDateLabel')"
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                filled
                                readonly
                                data-qa="fromDate"
                                :append-icon="isNoticeSelected || isLisaSelected ? '' : 'mdi-calendar'"
                                class="transferFunds--custom-textfield"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-if="!isNoticeSelected && !isLisaSelected"
                              v-model="formattedDate"
                              @input="menuOneTimePayment = false"
                              :allowed-dates="allowedDates"
                              :min="fromDate"
                              :color="primaryColor"
                              filled
                              data-qa="fromDate"
                              @change="repeatUpdateDateOTP"
                            ></v-date-picker>
                          </v-menu>
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-3" data-qa="domesticpayments-flex-2ql29k">
                        <v-text-field
                          v-model="transferNote"
                          :label="$t('domesticPayments.noteLabel')"
                          :color="primaryColor"
                          :rules="[rules.remarksLengthRule, rules.remarksFieldRule]"
                          filled
                          class="transferFunds--custom-textfield"
                          :maxlength="transferNoteMaxLength"
                         data-qa="domesticpayments-text-field-3bdow5"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row justify-space-between data-qa="domesticpayments-layout-a4z5l">
                      <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="domesticpayments-flex-4ybi7g">
                        <v-btn
                          @click="[...sameTypeTaxAcc, 'NACC', 'TXNA'].includes(selectedAccount?.accountType) ? handleModalDisplay(selectedAccount?.accountType)  : onNextButton()"
                          :color="primaryColor"
                          :disabled="
                            !isFormValid || isFormAccounts || hasExceededBalance
                          "
                          elevation="2"
                          class="text-capitalize ma-2 white--text py-2 px-4"
                           data-qa="domesticpayments-btn-pjqmrp">{{ $t("domesticPayments.reviewPaymentBtn") }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex v-else data-qa="domesticpayments-flex-0284qs">
      <DomesticPaymentsReview
        @domesticPaymentSuccessfull="initiateDomesticTransfer"
        @reset_isInitiateDomesticFailed="isInitiateDomesticFailed = false"
        :isInitiateDomesticFailed="isInitiateDomesticFailed"
        :config="{ payload }"
        :display="{ viewOnly }"
      />
    </v-flex>
    <!-- Penalty charge dialog box for transfer from NACC account -->
    <Modal
      v-if="confirmTXSVTransfer"
      :config="modalConfig.alertModal"
      @btn1Action="handleModalClose"
    >
      <span slot="modalContent" data-qa="domesticpayments-span-x3vx1i">
        {{ $t('transferfunds.ackConfirmMsg') }} <br data-qa="domesticpayments-br-j5mhao"><br data-qa="domesticpayments-br-32r5a"> {{ $t('transferfunds.ackQn') }}
      </span>
    </Modal>
    <!-- Add new payee OTP section -->
    <Modal
      v-if="enableOTPToAddPayee && showOTPScreen"
      @cancel="onOtpModalClose"
      :config="modalConfig.otp"
    >
      <span slot="modalContent" data-qa="domesticpayments-span-6p3qyh">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <NoticeCashIsaWarning
      v-if="confirmNACCTransfer"
      :subtitle="$t('transferfunds.withdrawImmediately')"
      :text="lossOfInterestWarning"
      @onCancel="handleModalClose"
      @onContinue="onNextButton"
    />
    <Modal
      v-if="showSuccessDialog"
      :config="modalConfig.successDialog"
      @btn1Action="newTransferRequest"
      @btn2Action="returnToDashboard"
      @btn3Action="downloadPaymentProofEnabled"
      >
    </Modal>
    <PaymentFailureDialog
      :show="failureDialog.show"
      :retry="false"
      :error-list="failureDialog.errorList"
      @goBack="handleGoBack"
      @cancelTransfer="newTransferRequest"
    />
  </v-flex>
</template>

<script>
import _ from 'lodash'
import store from '@/core/store'
import '@/styles/pages/login/login.scss'
import '@/styles/pages/transferFunds.scss'
import OtpInput from '@/components/common/OtpInput.vue'
import commonService from '@/service/commonService.js'
import getFormConfig from '@/util/formUtility.js'
import preload from '@/util/preload'
import moment from 'moment'
import event from '@/util/event'
import DomesticPaymentsReview from './DomesticPaymentsReview.vue'
import { minLen } from '@/core/_helpers/validationRules'
import UKFPSpayemntTemplate from '@/plugins/UKFPSconfig'
import Loader from '../../../../components/common/Loader.vue'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import PaymentSourceSelect from '../../../common/PaymentSourceSelect.vue'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'

export default {
  name: 'DomesticPayments',
  components: {
    Loader,
    OtpInput,
    DomesticPaymentsReview,
    PaymentFailureDialog,
    Form: () => import('@/components/DOB-Form/Form.vue'),
    Modal: () => import('@/components/common/Modal.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    NoticeCashIsaWarning: () => import('@/views/accounts/accountDetails/noticeCashISA/NoticeCashIsaWarning.vue'),
    TransferFundsLisaTooltip: () => import('../../TransferFunds/TransferFundsLisaTooltip.vue'),
    PaymentSourceSelect
  },
  mixins: [smeRolesMixin],
  data () {
    return {
      sameTypeTaxAcc: ['TXEA', 'TXSV'],
      valid: true,
      reviewScreen: false,
      isInitiateDomesticFailed: false,
      isFormValid: false,
      isPayeeFormValid: false,
      isSortCodeSearchFormValid: false,
      isFormAccounts: false,
      isAccountBalance: false,
      loaderEnabled: false,
      openPayee: false,
      enablePayeeForm: false,
      enableSortCodeSearchForm: false,
      menu: false,
      menuOneTimePayment: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      corporateId: '',
      userCorporates: [],
      corpName: '',
      defaultCorporateCode: '',
      userId: '',
      search: '',
      searchPayee: '',
      listOfAccounts: [],
      sortCodeResults: [],
      payload: {},
      viewOnly: {},
      isLeavingRoute: false,
      selectedAccount: undefined,
      selectedAccountNumber: '',
      payeeAccount: '',
      payeeAccountName: '',
      selectedPayeeSortCode: '',
      searchPayeeList: '',
      selectPayee: '',
      transferAmount: [],
      paymentFrequency: '',
      frequencyMonths: '',
      transferNote: '',
      payeeList: '',
      paymentDate: '',
      fromDate: moment().format('YYYY-MM-DD'),
      todaysDate: moment().format('YYYY-MM-DD'),
      repeatFromDate: moment().format('YYYY-MM-DD'),
      repeatMinAllowedDate: moment().format('YYYY-MM-DD'),
      repeatFormattedDate: '',
      formattedDate: '',
      formattedDateOTP: moment().format('YYYY-MM-DD'),
      minAllowedDate: moment().format('YYYY-MM-DD'),
      displayDateFormat: this.$appSettings.defaultConfigurations.dateFormat.uiFormat,
      enableOTPToAddPayee:
        this.$appSettings.defaultConfigurations.enableOTPToAddPayee,
      enableOTPToDomesticPayment:
        this.$appSettings.defaultConfigurations.enableOTPToDomesticPayment,
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      linkedNominatedAccDetails: {},
      enableRecurringPaymentsOption:
        this.$appSettings.defaultConfigurations.payments.enableRecurringPaymentsOption,
      nominatedAccountsConfig:
        this.$appSettings.defaultConfigurations.nominatedAccounts,
      accruedPenaltyCharges: this.$appSettings.defaultConfigurations.enableAccruedPenaltyCharges,
      isNominatedAccount: false,
      showOTPScreen: false,
      showLinkedAccounts: 0,
      isLogout: false,
      paymentMode: 0,
      isTransferComplete: false,
      domesticPaymentCharges: 0,
      UKFPSpayemntTemplate,
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        alertModal: {
          enabled: false,
          persistent: true,
          outlinedSaveBtn: false,
          outlinedCancelBtn: true,
          btn2Label: this.$t('closeAccount.btnCancel'),
          btn1Label: this.$t('closeAccount.btnContinue'),
          title: this.$t('transferfunds.naccConfirm'),
          width: 367,
          saveCallback: () => { this.onNextButton() }
        },
        successDialog: {
          enabled: false,
          persistent: true,
          dataListTranslation: 'domesticPayments',
          title: this.$t('paymentSuccessDialog.transferInitiated'),
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      quickPayment: {
        toAccount: '',
        transferAmount: [],
        isAccountBalance: false,
        fromDate: moment().format('YYYY-MM-DD'),
        reEnteredToAccount: '',
        selectedAccount: undefined,
        selectedAccountNumber: '',
        transferNote: '',
        isFormValid: false,
        toAccMaxLength:
          this.$appSettings.defaultConfigurations
            .fundTransferQuickPayToAccMaxlength
      },
      payeeForm: {
        sortCode: '',
        toAccount: '',
        branchName: '',
        bankName: '',
        accountName: '',
        reEnteredToAccount: '',
        payeeNameMaxLen:
          this.$appSettings.defaultConfigurations.payeeNameMaxlength.interBank
      },
      searchSortCodeForm: {
        sortCode: '',
        branchName: '',
        bankName: '',
        isSearchAvailable: true,
        minInputLength: 5
      },
      totalFundTabs: [this.$t('domesticPayments.registeredAccTitle')],
      totalPayeeTabs: [this.$t('domesticPayments.payeeAccount')],
      frequencyDays: [
        { state: 'Daily', val: 'DAILY' },
        { state: 'Weekly', val: 'WEEKLY' },
        { state: 'Fortnightly', val: 'FORTNIGHTLY' },
        { state: 'Monthly', val: 'MONTHLY' },
        { state: 'BI-Monthly', val: 'BI-MONTHLY' },
        { state: 'Quarterly', val: 'QUARTERLY' },
        { state: 'Half-Yearly', val: 'HALF-YEARLY' },
        { state: 'Yearly', val: 'YEARLY' }
      ],
      enableEBAVCheckForAddPayee: this.$appSettings.defaultConfigurations.enableEBAVCheckForAddPayee,
      schema: {
        searchSortCodeForm: { exists: true }
      },
      bankName: this.$appSettings.applicationSettings.bankName,
      beneficiaryList: [],
      fieldRules: (v) => !!v || 'Required Field',
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        requiredAmountRule: (v) =>
          (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired'),
        minValue: (v) => v >= 2 || this.$t('transferfunds.numberOfPaymentsMinValidation'),
        maxValue: (v) => v <= 10 || this.$t('transferfunds.numberOfPaymentsMaxValidation'),
        greaterThanZero: (v) => v > 0 || this.$t('errors.common.minAmountError'),
        isLimitValid: () =>
          this.transferAmount <= this.UKFPSpayemntTemplate.transactionLimit ||
          this.$t('domesticPayments.limitError'),
        remarksFieldRule: (v) => {
          if (!v) return true
          const regex = /^[a-zA-Z0-9][a-zA-Z0-9',.\s-]*$/
          const isValid = regex.test(v)
          return isValid || this.$t('errors.common.invalidInput')
        },
        remarksLengthRule: (v) => {
          if (!v) return true
          return v.length <= UKFPSpayemntTemplate.remarksMaxLength || this.$t('domesticPayments.noteError', { maxlength: UKFPSpayemntTemplate.remarksMaxLength })
        }
      },
      isOwnAccLinked: null,
      appSettingsNA: this.$appSettings.defaultConfigurations.nominatedAccounts,
      successResponse: '',
      showSuccessDialog: false,
      confirmNACCTransfer: false,
      confirmTXSVTransfer: false,
      chargeAmt: 0,
      hideChgAmt: false,
      penaltyDetails: {},
      transferNoteMaxLength: '',
      currentDate: moment().format('YYYY-MM-DD'),
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations,
      lisaWithdrawalCharges: null,
      confirmationDetails: [],
      failureDialog: {
        show: false,
        errorList: []
      },
      form: {
        selectedAccount: null,
        quickSelectedAccount: null
      },
      isAddPayeePermitted: {
        ukfps: false
      },
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
    }
  },
  async created () {
    this.transferNoteMaxLength = this.UKFPSpayemntTemplate.remarksMaxLength
    const self = this
    this.getFormData(`SearchSortCode-${this.$i18n.locale}`)
    const tomorrow = new Date()
    tomorrow.setDate(new Date().getDate() + 1)
    this.repeatMinAllowedDate = moment(tomorrow).format('YYYY-MM-DD')
    this.repeatFormattedDate = moment(tomorrow).format('YYYY-MM-DD')
    this.repeatFromDate = this.$formatter.formatDate(this.repeatFormattedDate)
    this.formattedDateOTP = this.$formatter.formatDate(this.fromDate)
    this.formattedDate = this.fromDate
    if (self.$route.params && self.$route.params.accountsList) {
      self.listOfAccounts = self.$route.params.accountsList
    } else {
      await self.getListofAccounts()
    }
    await this.updateListOfAccountsWithLisaDetails()
    if (this.$route.params && this.$route.params.accountNumber) {
      this.selectedAccountNumber = this.$route.params.accountNumber
      this.quickPayment.selectedAccountNumber =
        this.$route.params.accountNumber
      this.verifyAccount()
    }
    if (this.$route.params && this.$route.params.beneficiaryAccount) {
      this.payeeAccount = this.$route.params.beneficiaryAccount
    }
    if (this.$route.params && this.$route.params.payeeAccountNumber) {
      this.payeeAccountName = this.$route.params.payeeAccountNumber
      this.payeeAccount = this.$route.params.payeeAccountNumber
      this.payeeList = this.$route.params.payeeName
      this.selectedPayeeSortCode = this.$route.params.payeeSortCode
      this.getExistingPayeeList()
    }
    event.$on('open_userProfile', (isOpen) => {
      this.openPayee = false
    })
    event.$on('is_UKFPS_TransferComplete', (status) => {
      this.isTransferComplete = status
    })
    event.$on('IS_REVIEW_CLEAR', async ({ type }) => {
      this.reviewScreen = false
      if (type === 'Reset') {
        setTimeout(() => {
          this.resetPage()
        }, 100)
      }
      await this.getListofAccounts()
      await this.updateListOfAccountsWithLisaDetails()
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.enableOTPToAddPayee && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false
        this.addNewPayee()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    if (this.appSettingsNA.enableNominatedAccountFeatures) {
      this.isOwnAccLinked = 'own'
    }
    this.userId = JSON.parse(sessionStorage.getItem('customerCode')) || JSON.parse(sessionStorage.getItem('userId'))
    this.corporateId = JSON.parse(sessionStorage.getItem('corporateId'))
    this.userCorporates = JSON.parse(sessionStorage.getItem('userCorporates'))
    this.defaultCorporateCode = JSON.parse(sessionStorage.getItem('defaultCorporateCode'))
    this.corpName = this.userCorporates?.find(c => c.corporateCode === this.defaultCorporateCode)?.corporateDescription
    if (this.nominatedAccountsConfig.enableNominatedAccountFeatures && this.nominatedAccountsConfig.enablePaymentsOnlyToNominatedAccounts) {
      this.isNominatedAccount = true
    }
    const permissions = store.getters['profileStore/profileData']?.permissions
    this.isAddPayeePermitted.ukfps = this.isSmeRoleBasedAccessEnabled() ? permissions?.includes('ADD_AND_DELETE_UKFPS_PAYEES') : true
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successDialog.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  computed: {
    filteredItems () {
      if (this.listOfAccounts.length) {
        return _.orderBy(
          this.listOfAccounts.filter((item) => {
            if (!this.search) return this.listOfAccounts
            return (
              item.accountName
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              item.accountId.toLowerCase().includes(this.search.toLowerCase())
            )
          })
        )
      } else return 0
    },
    payeeSearchFilter () {
      if (this.beneficiaryList.length) {
        let temp = []
        temp = this.beneficiaryList.filter(item => {
          return this.showLinkedAccounts === 0 ? item.ownAccount === true : item.ownAccount === false
        })
        return _.orderBy(
          temp.filter((item) => {
            if (item.paymentSystem === 'UKFPS') {
              if (!this.searchPayee) return temp
              return (
                item.name
                  .toLowerCase()
                  .includes(this.searchPayee.toLowerCase()) ||
                item.accountIdentification
                  .toLowerCase()
                  .includes(this.searchPayee.toLowerCase())
              )
            }
          })
        )
      } else return []
    },
    sourceAccounts () {
      if (!this.listOfAccounts.length) return []

      const excludedMOO = this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList
      const sourceAccountsForRecurring = ['SVGS', 'CACC', 'TXEA']
      const isLisaStatusValid = (x) => x.accountType !== 'TXLA' || x?.lisaDetails?.lisaStatus === 'ACTIVE'

      const accounts = this.listOfAccounts
        .filter(account =>
          account.postingsRestriction !== 'DEBIT' &&
          account.currency === this.UKFPSpayemntTemplate.currency &&
          account.accountType !== 'TXFR' &&
          (account.accountStatus !== 'INACTIVE' || this.allowInactiveAccountTransactionalOperations) &&
          (account.accountOwnership !== 'JOINT' || !excludedMOO.includes(account.modeOfOperation.code)) &&
          (!this.isRecurring || sourceAccountsForRecurring.includes(account.accountType)) &&
          isLisaStatusValid(account)
        )

      return this.getFilteredAccounts(accounts)
    },
    showFilters () {
      return !this.appSettingsNA.enableTransferFundsOnlyToOwnAccounts && !this.isNominatedAccount
    },
    isRecurring () {
      return this.paymentMode === 1
    },
    isNoticeSelected () {
      return ['TXNA', 'NACC'].includes(this.selectedAccount?.accountType)
    },
    isLisaSelected () {
      return this.selectedAccount?.accountType === 'TXLA'
    },
    lossOfInterestWarning () {
      const currency = this.penaltyDetails?.chargeAmount?.currency ||
        this.penaltyDetails?.penaltyAmount?.currency ||
        this.selectedAccountNumberCurrency
      const amount = this.accruedPenaltyCharges
        ? this.$formatter.currency.format(this.penaltyDetails?.penaltyAmount?.value, currency)
        : this.$formatter.currency.format(this.chargeAmt, currency)
      return this.accruedPenaltyCharges
        ? this.$t('transferfunds.accruedPenaltyWarning', { amount })
        : `${this.$t('domesticPayments.lossOfInterestWarning', { amount })}`
    },
    selectedPayor () {
      return this.listOfAccounts.find(x => x.accountId === this.selectedAccountNumber)
    },
    settings () {
      const { payments } = this.$appSettings.defaultConfigurations
      return {
        lisaWithdrawalChargeEventNo: payments.lisaWithdrawalChargeEventNo
      }
    },
    customerDetails () {
      return store.getters['profileStore/profileData'].customerDetails
    },
    username () {
      return JSON.parse(sessionStorage.getItem('username'))
    },
    isPayorLisa () {
      return this.selectedPayor.accountType === 'TXLA'
    },
    preCalculatedCharges () {
      if (this.isPayorLisa) {
        return {
          amount: this.toDecimal(this.totalLisaCharges + this.domesticPaymentCharges),
          currency: this.selectedPayor.currency,
          suppressAdditionalCharges: false
        }
      }

      if (this.isNoticeSelected) {
        const charge = this?.penaltyDetails?.chargeAmount?.value ?? 0
        const tax = this?.penaltyDetails?.taxAmount?.value ?? 0
        return {
          amount: this.toDecimal(charge + tax),
          currency: this?.penaltyDetails?.chargeAmount?.currency ?? this.selectedPayor.currency,
          suppressAdditionalCharges: false
        }
      }

      return {
        amount: this.toDecimal(this.domesticPaymentCharges),
        currency: this.selectedPayor.currency,
        suppressAdditionalCharges: false
      }
    },
    totalLisaCharges () {
      return (this.lisaWithdrawalCharges ?? []).reduce((accumulator, charge) => {
        return accumulator +
          (charge?.chargeAmount?.value ?? 0) +
          (charge?.taxAmount?.value ?? 0)
      }, 0)
    },
    hasExceededBalance () {
      if (!this.form.selectedAccount || !this.transferAmount) return false

      const balance = this.form?.selectedAccount?.balance || 0
      const transferAmount = this.isRecurring ? this.quickPayment.transferAmount[0] : this.transferAmount[0]
      return transferAmount > balance
    }
  },
  methods: {
    handleModalClose () {
      if (this.confirmNACCTransfer || this.confirmTXSVTransfer) {
        this.confirmNACCTransfer = false
        this.confirmTXSVTransfer = false
        this.modalConfig.alertModal.enabled = false
        this.chargeAmt = 0
      }
    },
    async handleModalDisplay (acctType) {
      this.hideChgAmt = false
      this.modalConfig.alertModal.title = ''
      this.confirmTXSVTransfer = false
      this.confirmNACCTransfer = false

      if (this.sameTypeTaxAcc.includes(acctType)) {
        this.modalConfig.alertModal.cancelButton = this.$t('transferfunds.backButton')
        this.modalConfig.alertModal.saveButton = this.$t('transferfunds.proceed')
        this.modalConfig.alertModal.title = this.$t('transferfunds.ackConfirm')
        this.confirmTXSVTransfer = true
        this.modalConfig.alertModal.enabled = true
      }

      if (['NACC', 'TXNA'].includes(acctType)) {
        this.modalConfig.alertModal.cancelButton = this.$t('closeAccount.btnCancel')
        this.modalConfig.alertModal.saveButton = this.$t('closeAccount.btnContinue')
        this.modalConfig.alertModal.title = this.$t('transferfunds.naccConfirm')
        const accruedPayload = {
          transactionAmount: {
            value: parseFloat(this.transferAmount[0]),
            currency: this.selectedPayor.currency
          }
        }
        this.penaltyDetails = this.accruedPenaltyCharges
          ? await commonService.getAccruedPenaltyCharges(this.selectedAccountNumber, accruedPayload)
          : await commonService.getNoticeLossOfInterest(this.selectedAccountNumber, this.transferAmount)

        if (Array.isArray(this.penaltyDetails.causes) && 'code' in this.penaltyDetails.causes[0]) {
          if (this.penaltyDetails.causes[0].code === '40112540') {
            return
          }
          if (this.penaltyDetails.causes[0].code === '40205267') {
            this.onNextButton()
          }
        }

        if (this.penaltyDetails.status === 404 && this.penaltyDetails.detail === 'No Records Exist') {
          this.chargeAmt = this.$formatter.currency.customFormatter(0, this.UKFPSpayemntTemplate.currency)
          this.hideChgAmt = true
          this.onNextButton()
        }

        if ('chargeAmount' in this.penaltyDetails && 'taxAmount' in this.penaltyDetails) {
          this.chargeAmt = +this.penaltyDetails.chargeAmount.value + +this.penaltyDetails.taxAmount.value
          this.confirmNACCTransfer = true
          this.modalConfig.alertModal.enabled = true
        }

        if (this.penaltyDetails?.penaltyAmount) {
          if (this.penaltyDetails?.penaltyAmount?.value > 0.00) {
            this.confirmNACCTransfer = true
            this.modalConfig.alertModal.enabled = true
          } else {
            this.onNextButton()
          }
        }
      }
    },
    numbersOnly (e) {
      if (['e', '+', '-'].includes(e.key)) {
        e.preventDefault()
      }
    },
    showDivider (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    restrictDecimal (val) {
      if (val && val.length) {
        // Restrict the input to 2 decimal places
        this.transferAmount = val.match(/^\d+\.?\d{0,2}/)
      }
    },
    filterKey (e) {
      const key = e.key
      if (key === '.' || key === 'e') { return e.preventDefault() }
    },
    maskSortCode (code) {
      let maskedCode = ''
      if (code) {
        const sortCode = code.toString()
        for (let i = 0; i < sortCode.length; i++) {
          if (i % 2 === 0) {
            maskedCode = maskedCode + sortCode.substr(i, 2)
          } else if (i !== sortCode.length - 1) {
            maskedCode = maskedCode + '-'
          }
        }
      }
      return code ? maskedCode : ''
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    repeatUpdateDate () {
      this.repeatFromDate = this.$formatter.formatDate(this.repeatFormattedDate)
    },
    repeatUpdateDateOTP () {
      this.formattedDateOTP = this.$formatter.formatDate(this.formattedDate)
    },
    repeatResetDate () {
      this.repeatFromDate = this.$formatter.formatDate(this.repeatMinAllowedDate)
      this.repeatFormattedDate = (moment(moment(this.repeatFromDate, 'YYYY-MM-DD', true)).isValid()) ? this.repeatFromDate : (this.repeatFromDate ? moment(this.repeatFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '')
    },
    onNextButton () {
      this.confirmNACCTransfer = false
      this.paymentMode === 0 && this.currentDate === this.formattedDate ? this.validateDomesticTransfer() : this.nextValidate()
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: this.transactionId },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.processing') }
      ]
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: this.transactionId
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
    },
    async getFormData (formName) {
      try {
        const componentSchema = await commonService.getFormData(formName)
        const data = getFormConfig(componentSchema)
        this.schema.searchSortCodeForm = data
        event.$on('isValid', (arg) => {
          this.isSortCodeSearchFormValid = arg
        })
      } catch (e) {
        console.log(e)
      }
    },
    async resetPage () {
      // clears all fields
      if (this.$refs.form) {
        await this.$refs.form.reset()
        this.fromDate = moment().format('YYYY-MM-DD')
        this.formattedDateOTP = this.$formatter.formatDate(this.fromDate)
      }
      if (this.$refs.quickPaymentForm) {
        this.$refs.quickPaymentForm.reset()
      }
      // resets screens
      this.reviewScreen = false
      this.isFormValid = false
      this.isAccountBalance = false
      // this.isTransferComplete = false
      this.quickPayment.isFormValid = false
      this.quickPayment.isAccountBalance = false
      this.selectedPayeeSortCode = ''
      this.payeeAccountName = ''
      this.selectedAccount = null
      this.openPayee = false
      setTimeout(() => {
        this.resetDate()
        this.repeatResetDate()
      }, 100)
    },
    onClosePayeeDrawer () {
      if (!this.enablePayeeForm && !this.enableSortCodeSearchForm) {
        this.openPayee = !this.openPayee
      }
      if (this.enableSortCodeSearchForm) {
        // clears all search sortcode fields
        event.$emit('resetForm', true)
        this.$refs.searchSortCodeForm.reset()
        this.sortCodeResults = []
        this.searchSortCodeForm.isSearchAvailable = false
        this.enableSortCodeSearchForm = false
        this.enablePayeeForm = true
      } else {
        // clears all fields
        if (this.$refs.payeeForm) {
          this.$refs.payeeForm.reset()
        }
        this.enablePayeeForm = false
      }
    },
    onAddPayee () {
      if (this.enableEBAVCheckForAddPayee) {
        this.accountEbavCheck()
      } else this.validatePayeeAccount()
    },
    async accountEbavCheck () {
      try {
        const validatePayload = {
          accountNumber: this.payeeForm.toAccount,
          sortCode: this.removeMasking(this.payeeForm.sortCode),
          partyId: this.isSmeLogin ? this.corporateId : this.userId
        }
        const response = await commonService.accountEbavCheck(validatePayload)
        if (response && !response.causes && response.externalBankAccountVerification) {
          this.validatePayeeAccount()
        } else {
          this.dispatchError('Error', this.$t('domesticPayments.validatePayeeError'))
        }
      } catch (e) {
        console.log(e)
      }
    },
    showSearchForm () {
      this.enablePayeeForm = false
      this.enableSortCodeSearchForm = true
      this.sortCodeResults = []
      this.searchSortCodeForm.isSearchAvailable = true
    },
    onSortCodeSelect (data) {
      this.enablePayeeForm = true
      this.enableSortCodeSearchForm = false
      // clears all search sortcode fields
      this.schema.searchSortCodeForm.model.sortCode = ''
      this.schema.searchSortCodeForm.model.branchName = ''
      this.schema.searchSortCodeForm.model.bankName = ''
      this.payeeForm.sortCode = data.nationalid ? this.maskSortCode(data.nationalid) : ''
      this.payeeForm.bankName = data.instname ? this.convertToCapitalisedSentence(data.instname) : ''
    },
    async onSearchSortCode () {
      const searchPayload = {
        networkName: 'UKFPS',
        branch: this.schema.searchSortCodeForm.model.branchName,
        bankName: this.schema.searchSortCodeForm.model.bankName,
        directoryIdentifier: this.removeMasking(
          this.schema.searchSortCodeForm.model.sortCode
        ),
        reachability: 'A',
        wildCardSearch: true
      }
      const searchResponse = await commonService.searchUkfpsSortCode(
        searchPayload
      )
      if (searchResponse && !searchResponse.causes) {
        this.sortCodeResults = searchResponse
      }
      if (!searchResponse.length) {
        this.searchSortCodeForm.isSearchAvailable = false
      }
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    isSearchDataValid () {
      if (this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.sortCode) {
        this.schema.searchSortCodeForm.schema.sortCode.regex = '^([\\d \\w]{2}-[\\d \\w]{2}-[\\d \\w]{2})*$'
      } else { this.schema.searchSortCodeForm.schema.sortCode.regex = '' }
      if (this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.bankName) {
        this.schema.searchSortCodeForm.schema.bankName.rules = [minLen(5, 5)]
      } else { this.schema.searchSortCodeForm.schema.bankName.rules = [] }
      if (this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.branchName) {
        this.schema.searchSortCodeForm.schema.branchName.rules = [minLen(5, 5)]
      } else { this.schema.searchSortCodeForm.schema.branchName.rules = [] }

      if (
        this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.bankName &&
        this.schema.searchSortCodeForm.model.branchName && this.isSortCodeSearchFormValid) {
        return false
      } else if (
        this.schema.searchSortCodeForm.model && this.schema.searchSortCodeForm.model.sortCode &&
        this.isSortCodeSearchFormValid
      ) {
        return false
      } else return true
    },
    async validatePayeeAccount () {
      this.$refs.payeeForm.validate()
      try {
        const validatePayload = {
          accountNumber: this.payeeForm.toAccount,
          type: 'UKFPS',
          hostId: 'MPM',
          sortCode: this.removeMasking(this.payeeForm.sortCode)
        }
        const response = await commonService.validateAccount(validatePayload)
        if (response && !response.causes && response.valid) {
          if (this.enableOTPToAddPayee) {
            this.showOTPScreen = true
            this.modalConfig.otp.enabled = true
          } else {
            this.addNewPayee()
          }
        } else {
          this.dispatchError('Error', this.$t('domesticPayments.validatePayeeError'))
        }
      } catch (e) {
        console.log(e)
      }
    },
    async addNewPayee () {
      try {
        const storeData = this.$store.getters['profileStore/profileData']
        const customerFullName = storeData.customerDetails
          ? storeData.fullName
          : ''
        const payeePayload = {
          customerId: this.username,
          name: this.payeeForm.accountName || customerFullName,
          accountIdentificationType: 'PROPRIETARY',
          accountIdentification: this.payeeForm.toAccount,
          country: this.UKFPSpayemntTemplate.country,
          currency: this.UKFPSpayemntTemplate.currency,
          paymentSystem: 'UKFPS',
          bankIdentifier: this.removeMasking(this.payeeForm.sortCode),
          ownAccount: this.isOwnAccLinked === 'own'
        }
        const response = await commonService.createBeneficiaryAccount(payeePayload)
        if (response && !response.causes && response.details.customerId) {
          this.onOtpModalClose()
          this.$refs.payeeForm.reset()
          this.enablePayeeForm = false
          this.enableSortCodeSearchForm = false
          this.$store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('domesticPayments.addPayeeSuccessMsg'),
              type: 'success',
              component: 'dob-snackbar'
            }
          })
          // Refresh Existing Payee List
          setTimeout(() => {
            this.getExistingPayeeList()
          }, 100)
        } else {
          if (response?.internalType === 'OTP-ERROR') {
            this.modalConfig.otp.enabled = true
            event.$emit('otp_validation_failed', response)
            return
          }
          this.onOtpModalClose()
          if (response?.causes?.[0]?.code === '20600064') {
            return
          } else if (response?.causes?.[0]?.code === '20600463') {
            this.dispatchError(this.$t('systemMessages.customMessages.20600463.title'), this.$t('systemMessages.customMessages.20600463.message'))
          } else {
            this.dispatchError('Error', this.$t('domesticPayments.addNewPayeeError'))
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    async getListofAccounts () {
      this.loaderEnabled = true
      this.listOfAccounts = await preload.getAllCASAWithBalance(this.username)
      this.loaderEnabled = false
    },
    togglePayee (index) {
      this.payeeAccount = index.accountIdentification
      this.payeeAccountName = index.accountIdentification
      this.selectedPayeeSortCode = index.bankIdentifier
      this.payeeList = index.name
      this.openPayee = !this.openPayee
      this.verifyAccount('selectPayee')
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    listPayee () {
      if (!this.linkedNominatedAccDetails.payawayAccountId) {
        if (!this.openPayee) {
          this.getExistingPayeeList()
        }
        this.openPayee = !this.openPayee
      }
    },
    updateDate () {
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
    },
    resetDate () {
      this.formattedDate = this.fromDate
    },
    verifyAccount (triggeredFrom = undefined) {
      this.listOfAccounts.forEach((acc) => {
        const selectedType = this.selectedAccountNumber
          ? 'default'
          : 'quickPayment'
        switch (selectedType) {
          case 'quickPayment':
            if (acc.accountId === this.quickPayment.selectedAccountNumber) {
              this.quickPayment.selectedAccount = acc
              this.quickPayment.isAccountBalance = false
            }
            break
          default:
            if (acc.accountId === this.selectedAccountNumber) {
              this.selectedAccount = acc
              this.selectedAccountNumber === this.payeeAccount
                ? (this.isFormAccounts = true)
                : (this.isFormAccounts = false)
              if (triggeredFrom !== 'selectPayee' && this.transferAmount && this.transferAmount.length) {
                this.transferAmount = []
              }
              this.isAccountBalance = false
              if (this.isNoticeSelected || this.isLisaSelected) {
                this.formattedDate = this.fromDate
                this.formattedDateOTP = this.$formatter.formatDate(this.minAllowedDate)
                this.paymentMode = 0
              }
            }
            break
        }
      })
    },
    verifyBalance () {
      const selectedType = this.selectedAccountNumber
        ? 'default'
        : 'quickPayment'
      switch (selectedType) {
        case 'quickPayment':
          this.quickPayment.transferAmount > 0 &&
          this.quickPayment.transferAmount <=
            (this.quickPayment.selectedAccount
              ? this.quickPayment.selectedAccount.balance
              : '')
            ? (this.quickPayment.isAccountBalance = false)
            : (this.quickPayment.isAccountBalance = true)
          break
        default: {
          const temp = this.selectedAccount ? this.selectedAccount.balance : ''
          if (this.transferAmount > 0 &&
          this.transferAmount <= temp) {
            this.isAccountBalance = false
          } else this.isAccountBalance = true
          break
        }
      }
    },
    nextValidate (type) {
      this.reviewScreen = true
      switch (type) {
        case 'quickPayment':
          this.$refs.quickPaymentForm.validate()
          this.payload = {
            fromAcc: this.quickPayment.selectedAccountNumber,
            toAcc: this.quickPayment.reEnteredToAccount,
            transferAmount: this.quickPayment.transferAmount[0],
            paymentFrequency: 'ONCE',
            frequencyMonths: false,
            startDate: this.quickPayment.fromDate,
            transferNote: this.quickPayment.transferNote,
            domesticPaymentCharges: this.isFuturePayment() ? undefined : this.domesticPaymentCharges,
            currencyFormat: this.UKFPSpayemntTemplate.currency,
            fromAccount: this.form.quickSelectedAccount
          }
          this.viewOnly = {
            fromAccType: this.quickPayment.selectedAccount.accountType,
            senderAccName: this.quickPayment.reEnteredToAccount
          }
          break
        default:
          this.$refs.form.validate()
          this.selectedAccountNumber === this.payeeAccount
            ? (this.isFormAccounts = true)
            : (this.isFormAccounts = false)
          this.payload = {
            fromAcc: this.selectedAccountNumber,
            toAcc: this.payeeAccount,
            transferAmount: this.transferAmount[0],
            paymentFrequency: this.paymentMode === 0 ? 'ONCE' : this.paymentFrequency.val,
            frequencyMonths: this.paymentMode === 0 ? false : this.frequencyMonths,
            startDate: this.paymentMode === 0 ? this.formattedDate : this.repeatFormattedDate,
            accType: this.UKFPSpayemntTemplate.accountIdentificationType,
            transferNote: this.transferNote || `${this.UKFPSpayemntTemplate.currency}PaymentUKFPS`,
            domesticPaymentCharges: this.paymentMode === 0 ? this.isFuturePayment() ? undefined : this.domesticPaymentCharges : undefined,
            payeeSortCode: this.selectedPayeeSortCode,
            currencyFormat: this.UKFPSpayemntTemplate.currency,
            fromAccount: this.form.selectedAccount
          }
          this.viewOnly = {
            fromAccType: this.selectedAccount.accountType,
            senderAccName: `${this.payeeAccount} | ${this.selectedPayeeSortCode}`,
            payeeAccountName: this.payeeList
          }
          break
      }

      if (this.isNoticeSelected && !this.hideChgAmt) {
        this.viewOnly.chargeAmt = this.chargeAmt
        this.viewOnly.penaltyDetails = this.penaltyDetails
      }
      this.payload.selectedPayor = this.selectedPayor
      this.payload.lisaWithdrawalCharges = this.lisaWithdrawalCharges
    },
    isFuturePayment () {
      return (this.paymentMode === 0 ? this.formattedDate : this.repeatFormattedDate) !== this.currentDate
    },
    isAnyInputsFilled () {
      if (this.isRecurring) {
        return Boolean(
          this.selectedAccountNumber ||
            this.payeeAccount ||
            (this.transferAmount && this.transferAmount.length) ||
            this.paymentFrequency ||
            this.frequencyMonths
        )
      } else {
        return Boolean(
          this.selectedAccountNumber ||
            this.payeeAccount ||
            (this.transferAmount && this.transferAmount.length)
        )
      }
    },
    async getExistingPayeeList () {
      try {
        const response = await commonService.getBeneficiaries(this.username)
        if (response && response.items) {
          this.beneficiaryList = response.items
        }
      } catch (e) {
        console.log(e)
      }
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    getPayeeDetails () {
      const self = this
      for (const item of this.beneficiaryList) {
        if (item.accountIdentification === self.payeeAccount) return item
      }
      return false
    },
    async validateDomesticTransfer () {
      try {
        const d = moment()
        const toAccDetails = await this.getPayeeDetails()
        const customerDetails = this.customerDetails
        const isValidStatus = ['ACSP', 'ACCP']
        const body = {
          InitiationContext: {
            targetSchemeNm: 'UKFPS',
            saveOnError: false,
            sourceId: 'DOB'
          },
          CstmrCdtTrfInitn: {
            GrpHdr: {
              CreDtTm: d.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
            },
            PmtInf: [
              {
                PmtTpInf: {
                  InstrPrty: 'NORM',
                  LclInstrm: {
                    Cd: 'IMMEDIATEPAYMENT'
                  }
                },
                ReqdExctnDt: d.format('YYYY-MM-DD'),
                Dbtr: {
                  Nm: this.isSmeLogin ? this.corpName : customerDetails.fullName, // Loggedin customer name
                  Id: {
                    PrvtId: {
                      Othr: [
                        {
                          Id: this.isSmeLogin ? this.corporateId : customerDetails.partyID // Loggedin customer ID
                        }
                      ]
                    }
                  }
                },
                DbtrAcct: {
                  Id: {
                    Othr: {
                      Id: this.selectedAccountNumber // from account
                    }
                  }
                },
                CdtTrfTxInf: [
                  {
                    PmtId: {
                      InstrId:
                        this.transferNote ||
                        `${this.UKFPSpayemntTemplate.currency}PaymentUKFPS`, // remarks
                      EndToEndId: `DOB-${
                        this.UKFPSpayemntTemplate.currency
                      }-${Math.floor(Date.now() / 1000)}` // ChannelID-CCY-UnqiueTimeStamp
                    },
                    Amt: {
                      InstdAmt: {
                        Amt: this.transferAmount[0], // amount to transfer
                        Ccy: this.UKFPSpayemntTemplate.currency // curreny format
                      },
                      EqvtAmt: {
                        CcyOfTrf: this.UKFPSpayemntTemplate.currency
                      }
                    },
                    CdtrAgt: {
                      FinInstnId: {
                        ClrSysMmbId: {
                          MmbId: toAccDetails.bankIdentifier // sort code
                        }
                      }
                    },
                    Cdtr: {
                      Nm: toAccDetails.name, // to account holder name
                      PstlAdr: {
                        AdrTp: 'ADDR',
                        Ctry: 'GB'
                      }
                    },
                    CdtrAcct: {
                      Id: {
                        Othr: {
                          Id: this.payeeAccount // to account
                        }
                      }
                    }
                  }
                ]
              }
            ]
          }
        }

        if (this.isNoticeSelected && !this.hideChgAmt) {
          body.InitiationContext.PreCalculatedCharges = {
            amount: this.penaltyDetails?.chargeAmount?.value,
            currency: this.penaltyDetails?.chargeAmount?.currency,
            suppressAdditionalCharges: true
          }
        }

        if (['NACC', 'TXNA'].includes(this.selectedAccount?.accountType) && this.accruedPenaltyCharges) {
          delete body.InitiationContext.PreCalculatedCharges
        }

        if (this.isPayorLisa) {
          this.lisaWithdrawalCharges = await this.getLisaWithdrawalCharges()
          if (this.totalLisaCharges !== 0) {
            body.InitiationContext.PreCalculatedCharges = {
              amount: this.totalLisaCharges,
              currency: this.selectedPayor.currency,
              suppressAdditionalCharges: true
            }
          }
        }

        const resp = await commonService.validateDomesticTransfer(body)
        if (
          resp &&
          resp.Document &&
          isValidStatus.includes(
            resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
              .TxSts
          )
        ) {
          this.domesticPaymentCharges =
            resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
              .Charges.Amt || 0
          this.nextValidate()
        } else {
          this.reviewScreen = false
          if (resp?.causes?.[0]?.code === '20600087') {
            this.dispatchError(this.$t('systemMessages.customMessages.20600087.title'), this.$t('systemMessages.customMessages.20600087.message'))
          } else if (resp?.causes?.[0]?.code === '20600464') {
            this.dispatchError(this.$t('systemMessages.customMessages.20600464.title'), this.$t(resp.causes[0].message.replace('Beneficiary', this.$t('systemMessages.customMessages.20600464.message'))))
          } else {
            this.dispatchError(this.$t('systemMessages.customMessages.20600123.title'), this.$t('systemMessages.customMessages.20600123.message'))
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async initiateDomesticTransfer (e) {
      this.isTransferComplete = false
      this.confirmationDetails = e.summaryDetails
      try {
        const d = moment()
        const toAccDetails = await this.getPayeeDetails()
        const customerDetails = this.customerDetails
        const isValidStatus = ['ACSP', 'ACCP']
        const body = {
          InitiationContext: {
            targetSchemeNm: 'UKFPS',
            saveOnError: false,
            sourceId: 'DOB',
            PreCalculatedCharges: this.preCalculatedCharges
          },
          CstmrCdtTrfInitn: {
            GrpHdr: {
              CreDtTm: d.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
            },
            PmtInf: [
              {
                PmtTpInf: {
                  InstrPrty: 'NORM',
                  LclInstrm: {
                    Cd: 'IMMEDIATEPAYMENT'
                  }
                },
                ReqdExctnDt: d.format('YYYY-MM-DD'),
                Dbtr: {
                  Nm: this.isSmeLogin ? this.corpName : customerDetails.fullName, // Loggedin customer name
                  Id: {
                    PrvtId: {
                      Othr: [
                        {
                          Id: this.isSmeLogin ? this.corporateId : customerDetails.partyID // Loggedin customer ID
                        }
                      ]
                    }
                  }
                },
                DbtrAcct: {
                  Id: {
                    Othr: {
                      Id: this.selectedAccountNumber // from account
                    }
                  }
                },
                ChrgsAcct: {
                  Id: {
                    Othr: {
                      Id: this.selectedAccountNumber // from account number
                    }
                  }
                },
                CdtTrfTxInf: [
                  {
                    PmtId: {
                      InstrId:
                        this.transferNote ||
                        `${this.UKFPSpayemntTemplate.currency}PaymentUKFPS`, // remarks
                      EndToEndId: `DOB-${
                        this.UKFPSpayemntTemplate.currency
                      }-${Math.floor(Date.now() / 1000)}` // ChannelID-CCY-UnqiueTimeStamp
                    },
                    Amt: {
                      InstdAmt: {
                        Amt: Number((this.transferAmount[0] - this.totalLisaCharges).toFixed(2)),
                        Ccy: this.UKFPSpayemntTemplate.currency // curreny format
                      },
                      EqvtAmt: {
                        CcyOfTrf: this.UKFPSpayemntTemplate.currency // curreny format
                      }
                    },
                    CdtrAgt: {
                      FinInstnId: {
                        ClrSysMmbId: {
                          MmbId: toAccDetails.bankIdentifier // sort code
                        }
                      }
                    },
                    Cdtr: {
                      Nm: toAccDetails.name, // to account holder name
                      PstlAdr: {
                        AdrTp: 'ADDR',
                        Ctry: 'GB'
                      }
                    },
                    CdtrAcct: {
                      Id: {
                        Othr: {
                          Id: this.payeeAccount // to account
                        }
                      }
                    }
                  }
                ]
              }
            ]
          }
        }
        if (['NACC', 'TXNA'].includes(this.selectedAccount?.accountType) && this.accruedPenaltyCharges) {
          delete body.InitiationContext.PreCalculatedCharges
        }
        this.loaderEnabled = true
        const resp = await commonService.initiateDomesticTransfer(body)
        this.loaderEnabled = false
        if (
          resp &&
          resp.Document &&
          isValidStatus.includes(
            resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
              .TxSts
          )
        ) {
          let isoTimeString = await resp.Document.CstmrPmtStsRpt.OrgnlGrpInfAndSts.OrgnlCreDtTm
          let paymentTime = ''
          if (isoTimeString) {
            let date = new Date(isoTimeString)
            paymentTime = date?.toISOString().substr(11, 8)
          }
          const successResponse = {
            paymentType: 'UKFPS',
            fromAcc: this.selectedAccountNumber,
            toAcc: `${this.payeeAccount} | ${this.selectedPayeeSortCode}`,
            amt: this.transferAmount[0],
            chargeAmount: this.domesticPaymentCharges,
            currency: this.UKFPSpayemntTemplate.currency,
            transferNote:
              this.transferNote ||
              `${this.UKFPSpayemntTemplate.currency}PaymentUKFPS`,
            referenceID:
              resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0]
                .OrgnlEndToEndId,
            payeeAccountName: this.payeeList,
            fromAccType: this.selectedAccount.accountType,
            paymentTime
          }
          this.successResponse = successResponse
          this.transactionId = resp.Document.CstmrPmtStsRpt.OrgnlPmtInfAndSts[0].TxInfAndSts[0].OrgnlEndToEndId
          this.paymentDate = resp.Document.CstmrPmtStsRpt.OrgnlGrpInfAndSts.OrgnlCreDtTm
          // Parse and format the time
          // Document.CstmrPmtStsRpt.OrgnlGrpInfAndSts.OrgnlCreDtTm
          this.setDownloadData(paymentTime)
          this.modalConfig.successDialog.dataDetails = this.confirmationDetails
          this.modalConfig.successDialog.body = this.$t('paymentSuccessDialog.yourTransactionReference') + ' ' + this.successResponse.referenceID
          this.modalConfig.successDialog.enabled = true
          this.isLeavingRoute = false
          this.showSuccessDialog = true
          this.isTransferComplete = true
        } else {
          if (resp && resp.internalType === 'OTP-ERROR') {
            event.$emit('otp_validation_failed', resp)
            return
          }

          if (resp?.causes[0]?.code === '40507020') {
            this.dispatchError('Error', this.$t('systemMessages.customMessages.40507020_UKFPS.message'))
          } else {
            this.dispatchError('Error', this.$t('systemMessages.customMessages.10500001.message'))
          }
          event.$emit('reset_OTPField', true)
          this.isInitiateDomesticFailed = true
        }
      } catch (e) {
        console.log(e)
      }
    },
    setDownloadData (paymentTime) {
      this.downloadDataDetails = []
      this.downloadDataDetails.push(
        { label: 'fromAcc', value: this.payload?.selectedPayor?.accountName, subValue: this.$formatter.maskNumber(this.payload?.fromAcc) },
        { label: 'toAcc', value: this.viewOnly?.payeeAccountName, subValue: `${this.$formatter.maskNumber(this.payload?.toAcc)} | ${this.payload?.payeeSortCode}` },
        { label: 'amount', value: this.$formatter.currency.format(this.transferAmount[0], this.UKFPSpayemntTemplate?.currency) },
        {
          label: 'paymentDate',
          value: this.isFuturePayment() ? this.formattedDateOTP
            : this.$formatter.formatDateTime(this.paymentDate,
              {
                outputFormat: `${this.displayDateFormat} hh:mm:ss A`
              }
            )
        },
        { label: 'charges', value: this.$formatter.currency.format(this.domesticPaymentCharges, this.UKFPSpayemntTemplate?.currency) }
      )
    },
    resetNApayeeDetails () {
      this.linkedNominatedAccDetails = {}
    },
    async getLinkedAccountDetails () {
      const self = this
      const response = await commonService.getLinkedAccountDetails(
        this.selectedAccountNumber
      )
      if (response && response.payawayAccountId) {
        await this.getExistingPayeeList()
        this.loaderEnabled = true
        self.linkedNominatedAccDetails = response
        setTimeout(() => {
          const res = self.beneficiaryList.filter((item) => {
            return item.accountIdentification === response.payawayAccountId
          })
          if (res && res.length) {
            self.payeeAccountName = response.payawayAccountId
            self.payeeAccount = response.payawayAccountId
            self.payeeList = res[0].name
            self.selectedPayeeSortCode = res[0].bankIdentifier
          } else this.resetNApayeeDetails()
          this.loaderEnabled = false
        }, 500)
      } else this.resetNApayeeDetails()
    },
    verifyNominatedAccount () {
      if (this.selectedAccountNumber && this.appSettingsNA.enableNominatedAccountFeatures && this.appSettingsNA.enablePaymentsOnlyToNominatedAccounts) {
        const savingsCashISA = this.sourceAccounts.filter((item) => {
          return (
            item.accountType === 'SVGS' ||
            item.accountType === 'TXSV'
          )
        }).map((value) => { return value.accountId })
        this.isNominatedAccount = savingsCashISA.includes(this.selectedAccountNumber)
        const ownAccounts = this.beneficiaryList.filter(item => {
          return item.ownAccount
        }).map((value) => { return value.accountIdentification })
        if (this.isNominatedAccount) {
          this.showLinkedAccounts = 0
          this.openPayee = false
          const isToAccValid = ownAccounts.includes(this.payeeAccountName)
          if (!isToAccValid) {
            this.payeeAccountName = ''
            this.payeeAccount = ''
            this.payeeList = ''
            this.selectedPayeeSortCode = ''
          }
          this.getLinkedAccountDetails()
        } else this.resetNApayeeDetails()
        return this.isNominatedAccount
      }
      return false
    },
    dispatchError (title, content) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title,
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          content,
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    async getLisaWithdrawalCharges () {
      if (this.selectedPayor.lisaDetails.isCustomersAgeAboveLimit) return null

      const payload = {
        accountId: this.selectedPayor.accountId,
        eventNo: this.settings.lisaWithdrawalChargeEventNo,
        transactionAmount: {
          value: this.transferAmount[0],
          currency: this.selectedPayor.currency
        }
      }
      const response = await commonService.getEventCharges(payload)
      if (response?.causes?.length) {
        return null
      }
      return response.charges
    },
    async updateListOfAccountsWithLisaDetails () {
      const updatedAccounts = await Promise.all(
        this.listOfAccounts.map(async x => {
          if (x.accountType === 'TXLA') {
            const lisaDetails = await commonService.getLisaStatusDetails(x.accountId)
            return { ...x, lisaDetails }
          }
          return x
        })
      )
      this.listOfAccounts = updatedAccounts
    },
    async returnToDashboard () {
      await preload.getListOfAccounts(this.username)
      this.$router.push('/home')
    },
    async newTransferRequest () {
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
      await this.getListOfAccounts
      await this.updateListOfAccountsWithLisaDetails
      this.showSuccessDialog = false
    },
    handleGoBack () {
      // TODO: Handle back button
    },
    toDecimal (amount) {
      const number = Number(amount)
      if (isNaN(number)) {
        return NaN
      }
      return Number(number.toFixed(2))
    },
    onPaymentModeChanged () {
      this.selectedAccount = null
      this.form.selectedAccount = null
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isTransferComplete && this.isAnyInputsFilled()) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else if (to.path === '/confirmDomesticPayments') {
        this.to = to
        this.isLeavingRoute = false
        next()
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTPToAddPayee && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    },
    'form.selectedAccount' () {
      this.selectedAccountNumber = this.form.selectedAccount?.accountId ?? ''
      this.selectedAccount = this.form.selectedAccount
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
    event.$off('download_payment_proof')
  }
}
</script>
